(function ($) {
  Drupal.behaviors.stickyNodeFormatterV2 = {
    attached: false,
    attach: function (context) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      var $stickyNode = $('.js-sticky-node-v2', context);
      var $stickyWrapper = $('.js-sticky-node-content-wrapper', $stickyNode);
      var $stickyNodeContent = $('.js-sticky-node-content', $stickyNode);
      var $stickyNodeDraggable = $('.js-sticky-node-draggable', $stickyNode);
      var stickyPosition = $stickyNodeContent.offset();
      var $superCat = $('.js-supercat-container', context);
      var $gradientStart = $('.js-gradient-start', $stickyNode);
      var $gradientEnd = $('.js-gradient-end', $stickyNode);
      var $menuItems = $('.sticky-node-formatter__item', $stickyNode);
      var $stickyWrapperwidth = $stickyWrapper.width();
      var $stickyNodeDraggableWidth = $stickyNodeDraggable.width();
      var pathname = $(location).attr('pathname');
      var dir = $("html").attr("dir");
      var toDirectionStart = (dir === 'rtl') ? 'to right' : (dir === 'ltr') ? 'to left' : false;
      var toDirectionEnd = (dir === 'rtl') ? 'to left' : (dir === 'ltr') ? 'to right' : false;

      $(window).on(
        'scroll',
        _.throttle(function () {
          var currentPosition = $(window).scrollTop();
          var isCurrentPosHigher = currentPosition > stickyPosition.top;
          var $menuItemsHeight = $menuItems.height();
          $stickyNode.once().css('min-height', $menuItemsHeight);
          $stickyNode.toggleClass('filter-fixed-top', isCurrentPosHigher);
        }, 100)
      );

      if ($stickyWrapperwidth < 1550 && $(window).width() < 1920) {
        var draggableDistance = ($stickyNodeDraggableWidth - $stickyWrapperwidth) * -1;
        $stickyNodeDraggable.draggable({
          cursor: "pointer",
          axis: "x",
          containment: [draggableDistance, draggableDistance, 0, 0],
        });
      } else {
        $stickyNodeContent.addClass('short-nav');
      }

      if ($stickyNode.hasClass('gift-guide')) {
        if ($stickyNode.css('background-color')) {
          $stickyNode.once(function(){
            var color = $(this).css('background-color');
            if (dir.length > 0) {
              $gradientStart.css('background', 'linear-gradient('+ toDirectionStart + ', transparent,' + color + ') ');
              $gradientEnd.css('background', 'linear-gradient('+ toDirectionEnd + ', transparent,' + color + ') ');
            }
          });
        }

        $menuItems.each(function() {
          var href = $(this).find('.js-content-block--clickable').data('clickable');
          if(pathname === href) {
            var offset = $(this).offset().left;
            var outerWidth = $(this).outerWidth(true);
            var scrollPos = $(this).offset().left + $(this).outerWidth(true) / 2 - outerWidth;
            $(this).addClass('current');
          }
          $stickyNodeContent.scrollLeft(scrollPos);
        });

        $superCat.addClass('active');
      }
    }
  };
})(jQuery);
